// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'

on('click', '.js-show-more-environments', function (event) {
  const button = event.target as HTMLElement
  const container = button.closest<HTMLElement>('.js-hidden-environments-container')!
  const hiddenEnvironments = container.querySelector('.js-hidden-environments')
  const shownEnvironments = container.querySelector('.js-shown-environments')

  if (shownEnvironments) {
    /* eslint-disable-next-line github/no-d-none */
    shownEnvironments.classList.add('d-none')
  }

  if (hiddenEnvironments) {
    /* eslint-disable-next-line github/no-d-none */
    hiddenEnvironments.classList.remove('d-none')
  }
})

// used for new Primer gates approval dialog
on('click', '.js-gates-dialog-environment-checkbox', function (event) {
  const checkbox = event.target as HTMLInputElement
  const dialog = checkbox.closest<HTMLElement>('.js-gates-dialog')
  if (dialog == null) {
    // bail out if we don't have the Primer dialog
    return
  }

  const rejectButton = dialog.querySelector<HTMLInputElement>('.js-gates-approval-dialog-reject-button')
  const approveButton = dialog.querySelector<HTMLInputElement>('.js-gates-approval-dialog-approve-button')
  const countDisplay = dialog.querySelector<HTMLInputElement>('.js-gates-approval-dialog-count-display')
  if (rejectButton != null && approveButton != null && countDisplay != null) {
    const checked = dialog.querySelectorAll('.js-gates-dialog-environment-checkbox:checked')
    const invalid = checked.length === 0
    rejectButton.disabled = invalid
    approveButton.disabled = invalid
    countDisplay.hidden = invalid
    countDisplay.textContent = checked.length.toString()
  }

  const parentLabel = checkbox.closest('.ActionsApprovalOverlay-environment')
  if (parentLabel) {
    if (checkbox.checked) {
      parentLabel.classList.add('selected-approval-environment')
    } else {
      parentLabel.classList.remove('selected-approval-environment')
    }
  }
})
